import axios, { AxiosResponse } from 'axios';
import _ from 'lodash';
import { API_ROUTES } from '../constants';
import { HTTP_CONFIG } from '../defineTdm';


const getAccounts = async () => {
  const response: AxiosResponse<any> = await axios.get(API_ROUTES.accounts, HTTP_CONFIG);
  return response;
};

const getAccount = async (accountId: string) => {
  const url = API_ROUTES.account.replace(':id', accountId);
  return axios.get(url, HTTP_CONFIG);
};

const getAccountUsers = async (accountId: string) => {
  const url = API_ROUTES.accountUsers.replace(':id', accountId);
  const response: AxiosResponse<any> = await axios.get(url, HTTP_CONFIG);
  return response;
};

const getSessions = async () => {
  const response: AxiosResponse<any> = await axios.get(API_ROUTES.sessions, HTTP_CONFIG);
  return response;
};

const getAccountEntitlements = async (accountId: string) => {
  const url = API_ROUTES.accountEntitlements.replace(':id', accountId);
  const getOrgNodes = (node: any, level: number = 0): any[] => {
    let ret: any[] = [];
    if (node.id && node.name) {
      ret.push({
        id: node.id,
        name: node.name,
        level: level,
      });

      if (node.children && _.isArray(node.children)) {
        node.children.forEach((child: any) => {
          ret = ret.concat(getOrgNodes(child, level + 1));
        });
      }
    }
    return ret;
  };
  const response: AxiosResponse<any> = await axios.get(url, HTTP_CONFIG);
  const ret: any = { status: response.status };
  if (
    response.status === 200 &&
    response.data.accountId &&
    response.data.rootNode
  ) {
    ret.data = {
      accountId: response.data.accountId,
      nodes: getOrgNodes(response.data.rootNode),
      assignedOrgNodeId: response.data.rootNode.id
    };
    ret.status = 200;
  }
  return ret;
};

const getUserEntitlements = (accountId: string, userId: string) => {
  const url = API_ROUTES.userEntitlements
    .replace(':accountId', accountId)
    .replace(':id', userId);
  return axios.get(url, HTTP_CONFIG);
};

const getAllUserEntitlements = (accountId: string) => {
  const url = API_ROUTES.allUserEntitlements.replace(':accountId', accountId);
  return axios.get(url, HTTP_CONFIG);
};

const sudoAs = (userId: string) => {
  const url = API_ROUTES.sudoAs;
  return axios.post(url, { userId: userId }, HTTP_CONFIG);
};

const deleteSessions = async (sessions: any) => {
  const url = API_ROUTES.sessions;
  const config = {
    ...HTTP_CONFIG,
    headers: {
      ...HTTP_CONFIG.headers,
      'Content-Type': 'application/json;charset=utf-8',
    },
    data: sessions,
  };
  return axios.delete(url, config);
};

const refreshUserEntitlements = async (users: any[]) => {
  const userMap: any = {};
  users.forEach(u => {
    if (u.user.aav1UserId) {
      userMap[u.user.aav1UserId] = u;
    }
  });

  const accts: any = {};
  for (const u of Object.values(userMap)) {
    const acctId = (u as any).user.accountId;
    if (!accts[acctId]) {
      accts[acctId] = true;
      const resp = await getAllUserEntitlements(acctId);
      if (resp.status === 200 && resp.data) {
        resp.data.forEach((userEnt: any) => {
          if (userEnt.id in userMap) {
            userMap[userEnt.id].user.entitlements = userEnt;
          }
        });
      }
    }
  }
};

const refreshUsers = async (users: any[], account: string) => {
  const resp = await getAccountUsers(account);
  users.length = 0;
  if (resp.status === 200 && resp.data) {
    if (_.isArray(resp.data)) {
      users.push(...resp.data);
    }
    await refreshUserEntitlements(users);
  }
};

export const AdminService = {
  getAccounts,
  getAccount,
  getAccountUsers,
  getSessions,
  getAccountEntitlements,
  getUserEntitlements,
  getAllUserEntitlements,
  sudoAs,
  deleteSessions,
  refreshUserEntitlements,
  refreshUsers,
};